import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title, Subtitle } from 'app/src/styles';
import { useNavigate, useParams } from 'app/src/utils/routing';

import { PROVIDER, UPDATE_PROVIDER } from './queries';
import { FIELDS } from './new';

const Provider = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data } = useQuery(PROVIDER, { variables: { id } });

  useEffect(() => {
    if (data) {
      reset(defaultValues({ fields: FIELDS, resource: data.provider }));
    }
  }, [data]);

  const { submit: updateProvider, formStatus, errorMessage } =
    useFormSubmit(UPDATE_PROVIDER, {
      onCompleted: () => navigate('/providers'),
    });

  const onSubmit = input => {
    updateProvider({
      variables: { input: { id, ...prepareInput(input, FIELDS) } }
    });
  };

  const fields = { ...FIELDS };

  return (
    <View>
      <Title>{data?.provider.name}</Title>

      <Subtitle>Client: {data?.provider.client.name}</Subtitle>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default Provider;
